import JsonAsFormData from 'json-form-data';

export type ValidJSONValue = string | number | boolean | File | Blob | Date | null | undefined | string[];
export type ObjectWithValidJSONValues = { [key: string]: ValidJSONValue };

export function toFormData(body: ObjectWithValidJSONValues): FormData {
  return JsonAsFormData(body, {
    includeNullValues: true,
    mapping: (value: ValidJSONValue): any => (value === null ? '' : value),
  });
}

export function appendAsJSONFile(requestBody: FormData, property: string, data: ObjectWithValidJSONValues): void {
  requestBody.append(
    property,
    new Blob([JSON.stringify(data)], {
      type: 'application/json',
    }),
  );
}
